export default __webpack_public_path__ + "static/media/logo-parabens.c8258c15.webp";